module.exports = __webpack_public_path__ + "static/img/huangjiachongwu.2dbb26b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/huangjiachongwu.jpg
// module id = kJt8
// module chunks = 0